import { Box, Chip, Typography } from '@mui/material';
import type { TFunction } from 'i18next';
import LogbookActions from '../components/LogbookTableActions';
import { LogbookTemplate } from '../types/loogBookTypes';

export const columns = (
  currentQueryKey: any,
  t: TFunction,
  prefetchLogbookDetails?: (row: LogbookTemplate) => void
) => [
    {
      field: 'name',
      headerName: t('logbook.templates.columns.logbookDetails', 'Logbook Details'),
      align: 'left' as const,
      width: '60%',
      renderCell: (value: string, row: LogbookTemplate) => (
        <Box>
          <Typography variant="body1" fontWeight="bold" sx={{ marginBottom: '2px' }}>
            {row.name || t('logbook.templates.columns.noName', 'No Name')}
          </Typography>
          <Typography variant="body2" >
            {row.description}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'type',
      headerName: t('logbook.templates.form.type', 'Type'),
      align: 'center',
      renderCell: (value: string, row: LogbookTemplate) => {
        return (
          <Chip
            label={value}
            sx={{
              color: 'primary.main',
              border: '1px solid #BBD5EB',
              background: 'none',
            }}
          />
        );
      },
    },
    {
      field: 'action',
      headerName: t('common.action', 'Action'),
      align: 'right',
      getActions: (row: LogbookTemplate) => {
        return (
          <LogbookActions
            row={row}
            queryKey={currentQueryKey}
            onEditHover={prefetchLogbookDetails}
          />
        );
      },
    },
  ];